export const modalVariants = {
  _cssClass: "anim-modal-slide-in",
  hidden: { opacity: 0, x: "100%" },
  visible: {
    opacity: 1,
    x: "0%",
    transition: { type: "spring", stiffness: 150, damping: 20 },
  },
  exit: { opacity: 0, y: "100%", transition: { duration: 0.2 } },
};

// Themes / Admin panel - slides in from right, exits to right
export const modalVariantsForThemes = {
  _cssClass: "anim-panel-slide-in",
  hidden: { opacity: 0, x: "100%", scale: 0.97, originX: 1, originY: 0 },
  visible: {
    opacity: 1,
    x: 0,
    scale: 1,
    transition: { type: "spring", stiffness: 180, damping: 24 },
  },
  exit: {
    opacity: 0,
    x: "100%",
    scale: 0.97,
    transition: { duration: 0.25, ease: "easeIn" },
  },
};

export const childVariants = {
  _cssClass: "anim-fade-up",
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { type: "spring", stiffness: 60, damping: 15, delay: 0.05 },
  },
  exit: { opacity: 0, y: 20, transition: { duration: 0.2 } },
};

export const childVariantsDown = {
  _cssClass: "anim-fade-down",
  hidden: { opacity: 0, y: -20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { type: "spring", delay: 0.05 },
  },
  exit: { opacity: 0, y: 20, transition: { duration: 0.2 } },
};

// Common container variants used across multiple components
export const containerVariants = {
  _cssClass: "anim-fade-in",
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.1, delayChildren: 0.05 },
  },
};

// Variant for sections with slower stagger
export const containerVariantsSlow = {
  _cssClass: "anim-fade-in",
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.3, delayChildren: 0.2 },
  },
};

// Common child variants with spring animation (medium speed)
export const childVariantsMedium = {
  _cssClass: "anim-fade-up",
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { type: "spring", stiffness: 150, damping: 10 },
  },
};

// Child variants with slower spring animation
export const childVariantsSlow = {
  _cssClass: "anim-fade-up-slow",
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { type: "spring", stiffness: 50, damping: 20 },
  },
};

// Accordion animation variants
// Used for accordion-style expand/collapse animations (e.g., admin panel, themes panel)

// Container that wraps the accordion content - animates height
export const accordionContainer = {
  _cssClass: "anim-accordion-in",
  hidden: { height: 0, opacity: 0 },
  visible: {
    height: "auto",
    opacity: 1,
    transition: { duration: 0.3, ease: "easeInOut" },
  },
  exit: {
    height: 0,
    opacity: 0,
    transition: { duration: 0.3, ease: "easeInOut" },
  },
};

// Wrapper for accordion content - fades in/out
export const accordionWrapper = {
  _cssClass: "anim-accordion-wrapper",
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { duration: 0.3, ease: "easeInOut" },
  },
  exit: {
    opacity: 0,
    transition: { duration: 0.3, ease: "easeInOut" },
  },
};

// Individual items inside accordion - slides up on both entry and exit
export const accordionItem = {
  _cssClass: "anim-accordion-in",
  hidden: { opacity: 0, y: -10 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.2, ease: "easeInOut" },
  },
  exit: {
    opacity: 0,
    y: -10,
    transition: { duration: 0.2, ease: "easeInOut" },
  },
};

// Chatbot window - slides up from bottom-left corner
export const chatWindowVariants = {
  _cssClass: "anim-chat-window-in",
  hidden: { opacity: 0, y: 16, scale: 0.97, originX: 0, originY: 1 },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: { type: "spring", stiffness: 380, damping: 28 },
  },
  exit: {
    opacity: 0,
    y: 16,
    scale: 0.97,
    transition: { duration: 0.1, ease: "easeIn" },
  },
};

// Chatbot bubble trigger button
export const chatBubbleVariants = {
  _cssClass: "anim-chat-bubble-in",
  hidden: { opacity: 0, scale: 0 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: { type: "spring", stiffness: 300, damping: 18, delay: 0.6 },
  },
  exit: { opacity: 0, scale: 0, transition: { duration: 0.15 } },
};

// Individual chatbot message bubble - fades + slides up
export const chatMsgVariants = {
  _cssClass: "anim-chat-msg-in",
  hidden: { opacity: 0, y: 6 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { type: "spring", stiffness: 320, damping: 24 },
  },
};
